import { render, staticRenderFns } from "./weightage_main.vue?vue&type=template&id=3dc5c4f4&"
import script from "./weightage_main.vue?vue&type=script&lang=js&"
export * from "./weightage_main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports